import type { ReactNode } from "react";
import { InfoField } from "../InfoField";

interface ConjunctionFieldProps {
  label: string;
  value?: ReactNode;
  strong?: boolean;
  tooltip?: string;
  tone?: "default" | "danger" | "muted" | "warning";
}

export const ConjunctionField = (props: ConjunctionFieldProps) => (
  <InfoField {...props} />
);
